import { render, staticRenderFns } from "./AssignmentStepperForm.vue?vue&type=template&id=162dd950"
import script from "./AssignmentStepperForm.vue?vue&type=script&lang=js"
export * from "./AssignmentStepperForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports